import Axios, { AxiosError } from "axios";
import { swpcURL } from "config/api";

const axios = Axios.create({
  baseURL: swpcURL,
});

export { AxiosError };
export const thrownResponse = (res: any): never => {
  throw new Error(res?.data?.message);
};

export default axios;
